<template>
  <v-dialog v-if="value" class="modal">
    <div class="modal-content">
      <!-- 모달 내용 -->
      <p>This is a modal!</p>
      <button @click="closeModal">Close</button>
    </div>
  </v-dialog>
</template>
  
  <script>
  export default {
    props: {
      value: Boolean
    },
    data() {
    return {

    };
  },
    methods: {
        closeModal() {
        this.$emit('input', false);
      }
    },
  };
  </script>

<style scoped>

</style>